export const STATUS_PENDING = "PENDING";
export const LABEL_TYPE_85x11 = "EightFiveByEleven";
export const LABEL_TYPE_4x6 = "FourBySix";
export const PAYMENT_TYPE_THIRDPARTY = "ThirdParty";
export const PAYMENT_TYPE_SENDER = "Sender";
export const PACKAGING_TYPES = [
  "package",
  "envelope",
  "courier-pack",
  "freight",
];
export const DEFAULT_PACKAGING_TYPE = "package";
export const PICKUP_LOCATIONS = [
  "OutsideDoor",
  "FrontPorch",
  "Office",
  "SideDoor",
  "Basement",
  "FrontDesk",
  "BetweenDoors",
  "Security",
  "Counter",
  "Lobby",
  "Mailbox",
  "GateHouse",
  "Desk",
  "Kiosk",
  "Shipping",
  "ProShop",
  "FrontDoor",
  "Receiving",
  "Reception",
  "BackDoor",
  "Lab",
  "MailRoom",
  "Garage",
  "Pharmacy",
  "ServiceCounter",
  "PartsDepartment",
];
export const DEFAULT_PICKUP_LOCATION = "Office";
export const WEIGHT_UNITS = ["kg", "lb"];
export const DEFAULT_WEIGHT_UNIT = "kg";
export const SHIPMENT_STATUS_DRAFT = "DRAFT";
export const SHIPMENT_STATUS_ESTIMATED = "ESTIMATED";
export const SHIPMENT_STATUS_CREATED = "CREATED";
export const SHIPMENT_STATUS_PICKUP_CREATED = "PICKUP_CREATED";
export const SHIPMENT_STATUS_IN_TRANSIT = "IN_TRANSIT";
export const SHIPMENT_STATUS_DELIVERED = "DELIVERED";
export const SHIPMENT_STATUS_CANCELLED = "CANCELLED";

export const LABEL_TYPES = [LABEL_TYPE_85x11, LABEL_TYPE_4x6];

export const PAYMENT_TYPES = ["Sender", "ThirdParty"];

export const SHIPMENT_STATUS = [
  SHIPMENT_STATUS_DRAFT,
  SHIPMENT_STATUS_ESTIMATED,
  SHIPMENT_STATUS_CREATED,
  SHIPMENT_STATUS_PICKUP_CREATED,
  SHIPMENT_STATUS_IN_TRANSIT,
  SHIPMENT_STATUS_DELIVERED,
  SHIPMENT_STATUS_CANCELLED,
];
